export default __webpack_public_path__ + "static/media/GlobalOutlined.5d30283e.svg";